import _ from 'lodash';
import moment from 'moment';
import {
  SET_APP_INFO,
  SET_FILE_ATTRIBUTE,
  LOAD_FILES_IN_PROGRESS,
  LOAD_FILES_SUCCESS,
  LOAD_FILES_FAILURE,
  LOAD_FILES_FILTERED_SUCCESS,
  LOAD_FILES_FILTERED_FAILURE,
  SEND_INFO_SUCCESS,
  SEND_INFO_FAILURE,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAILURE,
  UPATE_FILE_REVIEW_STATUS_SUCCESS,
  GET_REVIEW_FILES_SUCCESS,
  SET_PAGE_PARAM,
  GET_PAGE_PARAM_VALUE,
  SET_USER_INFO,
  GET_USER_INFO,
  SET_REVIEW_INFO,
  GET_REVIEW_INFO,
  GET_OUTPUT_REVIEW_STATUS_GROUP_SUCCESS,
  GET_DOC_REVIEW_STATUS_GROUP_SUCCESS,
  SET_REVIEW_ASSIGN_INFO,
  GET_REVIEW_ASSIGN_INFO,
  ADD_REVIEW_ASSIGN,
  REMOVE_REVIEW_ASSIGN,
  UPDATE_REVIEW_ASSIGN_SELECT,
  UPDATE_REVIEW_ASSIGN_ALLOW_DOWNLOAD,
  SET_USERS,
  GET_USERS,
  SET_MILESTONES,
  SET_MILESTONE_ID,
  GET_SUMMARY_OVERALL_SUCCESS,
  UPDATE_OUTPUT_FILE_STATUS_SUCCESS,
  GET_OUTPUT_FILE_TOC_INFO_SUCCESS,
  UPDATE_STATUS_BY_RB_SUCCESS,
  UPDATE_STATUS_BY_LP_SUCCESS,
  UPDATE_OUTPUT_GROUP_DUE_DATE_SUCCESS,
  UPDATE_DOC_GROUP_DUE_DATE_SUCCESS,
  SEND_EMAIL_SUCCESS,
  CLEAR_MESSAGE_DISPLAY,
  UPDATE_DOC_FILE_STATUS_SUCCESS,
  UPDATE_DOC_FILE_DATA,
  GET_DOC_SUMMARY_OVERALL_SUCCESS,
  CHECK_OUTPUT_FILE_REMOVE_SUCCESS,
  SET_LOGIN_INFO,
  UPDATE_ADHOC_INFO_SUCCESS,
  SEARCH_ADHOC_SUCCESS,
  GET_ADHOC_CONTROL_VALUE_SUCCESS,
  LOAD_SUPPORT_SUCCESS,
  UPDATE_STUDY_LIST_SUCCESS,
  UPDATE_MILESTONE_LIST_SUCCESS,
  UPDATE_RELATED_TASK_LIST_SUCCESS,
  GET_ADHOC_REQUEST_SUCCESS,
  GET_ADHOC_REQUESTERS_SUCCESS,
  UPDATE_ADHOC_ATTACHMENTS_SUCCESS,
  REMOVE_ADHOC_ATTACHMENT_SUCCESS,
  UPDATE_ADHOC_IMAGE_SUCCESS,
  REMOVE_ADHOC_IMAGE_SUCCESS,
  UPDATE_REVIEW_INFO_SUCCESS,
  SET_SEARCH_INFO,
} from './actions';

export const appInfo = (state = { web_session_timeout:5000 }, action) => {
  const { type, payload } = action;
  // console.log('>>> appInfo reducer:', type, payload);
  switch (type) {
  case SET_APP_INFO:
    // console.log('>>> appInfo SET_USER_INFO:', payload);
    payload.previous_adhoc_request_date =
      moment(payload.previous_adhoc_request_date).format('MM/DD/YYYY');
    return Object.assign({}, state, payload);
  case LOAD_SUPPORT_SUCCESS:
    return Object.assign({}, state, payload);
  case UPDATE_STUDY_LIST_SUCCESS:
    return Object.assign({}, state, payload);
  case UPDATE_MILESTONE_LIST_SUCCESS:
    return Object.assign({}, state, payload);
  case UPDATE_RELATED_TASK_LIST_SUCCESS:
    return Object.assign({}, state, payload);
  default:
    return state;
  }
}

export const files = (state = [], action) => {
  const { type, payload } = action;
  let resultFiles = [];
  switch (type) {
  case SET_FILE_ATTRIBUTE: {
    const { param } = payload;
    // const [file] = state.filter( file => file.fileName === param.fileName );
    // console.log('>>> file:', file);
    let files = null;
    files = state.map( file => {
      if (file.fileName === param.fileName) {
        if (param.hasOwnProperty('isComplete')) {
          console.log('files change - isComplete', param.fileName);
          file.statusId = param.isComplete ? 4 : 2;  // TODO: use 2 for incomplete, 4 for complete
        }
      }
      return file;
    });
    // set file selected if param has isSelected
    if (param.hasOwnProperty('isSelected')) {
      // console.log('files change - isSelected', param.fileName);
      files = state.map( file => {
        if (file.fileName === param.fileName) {
          file.isSelected = true;
        } else {
          file.isSelected = false;
        }
        return file;
      });
    }
    // console.log('>>> files:', files);
    return files;
  }
  case LOAD_FILES_SUCCESS: {
    const { files } = payload;
    // console.log('>>>', files);
    return files;
  }
  case LOAD_FILES_FAILURE:
    return state;
  case LOAD_FILES_IN_PROGRESS:
    return state;
  case UPATE_FILE_REVIEW_STATUS_SUCCESS:
    // console.log('>>> UPATE_FILE_REVIEW_STATUS_SUCCESS state:', state);
    // console.log('>>> UPATE_FILE_REVIEW_STATUS_SUCCESS payload:', payload);
    let param = payload.param;
    let files = _.map(state, function(file) {
      if (file.fileName === param.fileName) {
        // console.log('--> update ' + file.fileName + ' to ' + param.isComplete);
        file.isComplete = param.isComplete;
        return file;
      } else {
        return file;
      }
    })
    // console.log('>>> UPATE_FILE_REVIEW_STATUS_SUCCESS files:', files);
    return files;
  case GET_REVIEW_FILES_SUCCESS:
    // console.log('>>> GET_REVIEW_FILES_SUCCESS payload:', payload);
    // console.log('>>> GET_REVIEW_FILES_SUCCESS state:', state);
    resultFiles = _.map(state, function(file) {
      let matchedFiles = _.filter(payload, function(statusFile) {
        // console.log('--->', statusFile, statusFile.fileName, file.fileName);
        return statusFile.file_name === file.fileName;
      });
      let matchedFile = matchedFiles[0];
      if (matchedFile) {
        file.isComplete = (matchedFile.status === 1);
      }
      return file;
    });
    // console.log('--> resultFiles', resultFiles);
    return resultFiles;
  case UPDATE_OUTPUT_FILE_STATUS_SUCCESS:
    // console.log('>>> UPDATE_OUTPUT_FILE_STATUS_SUCCESS payload', payload);
    resultFiles = _.map(state, function(file) {
      if (file.fileName === payload.filename) {
        file.statusId = payload.statusId;
      }
      return file;
    });
    return state;
  case GET_OUTPUT_FILE_TOC_INFO_SUCCESS:
    // console.log('>>> GET_OUTPUT_FILE_TOC_INFO_SUCCESS payload', payload);
    resultFiles = _.map(state, function(file) {
      let [matchedFile] = _.filter(payload, function(statusFile) {
        return statusFile.output_file_name === file.fileName;
      });
      // console.log('>>> matchedFile:', matchedFile);
      if (matchedFile) {
        file.output_number = matchedFile.output_number;
        file.output_title = matchedFile.output_title;
      }
      return file;
    });
    return resultFiles;
  case UPDATE_STATUS_BY_RB_SUCCESS:
    // console.log('>>> UPDATE_STATUS_BY_RB_SUCCESS payload', payload);
    resultFiles = _.map(state, function(file) {
      if (file.fileName === payload.filename) {
        file.requireChange = (payload.requireChange === 'Yes') ? 'Yes' : 'No';
      }
      return file;
    });
    return resultFiles;
  case UPDATE_STATUS_BY_LP_SUCCESS:
    // console.log('>>> UPDATE_STATUS_BY_LP_SUCCESS payload', payload);
    resultFiles = _.map(state, function(file) {
      if (file.fileName === payload.filename) {
        file.lpAgreeChange = (payload.requireChange === 'Yes') ? 'Yes' : 'No';
      }
      return file;
    });
    return resultFiles;
  case UPDATE_DOC_FILE_STATUS_SUCCESS:
    // console.log('>>> UPDATE_DOC_FILE_STATUS_SUCCESS payload', payload);
    resultFiles = _.map(state, function(file) {
      if (file.fileName === payload.filename) {
        file.statusId = payload.statusId;
      }
      return file;
    });
    return state;
  case UPDATE_DOC_FILE_DATA:
    // console.log('>>> UPDATE_DOC_FILE_DATA payload', payload);
    resultFiles = _.map(state, function(file) {
      if (file.fileName === payload.filename) {
        for (var property in payload) {
          file[property] = payload[property];
        }
      }
      return file;
    });
    return state;
  case CHECK_OUTPUT_FILE_REMOVE_SUCCESS:
    // console.log('>>> CHECK_OUTPUT_FILE_REMOVE_SUCCESS', payload);
    // output file remove call - status set to 5
    resultFiles = _.map(state, function(file) {
      if (file.fileName === payload.filename && payload.remove === true) {
        file.statusId = 5;
      }
      return file;
    });
    return resultFiles;
  default:
    return state;
  }
}

export const filesFiltered = (state = [], action) => {
  const { type, payload } = action;
  let resultFiles = [];
  switch (type) {
  case LOAD_FILES_FILTERED_SUCCESS: {
    const { files, filter } = payload;
    // console.log('>>> files filter:', filter);
    switch (filter) {
    case 'require_change':
      resultFiles = _.filter(files, file => file.requireChange === 'Yes');
      break;
    case 'table':
      resultFiles = _.filter(files, file => file.outputType === 'Table');
      break;
    case 'figure':
      resultFiles = _.filter(files, file => file.outputType === 'Figure');
      break;
    case 'listing':
      resultFiles = _.filter(files, file => file.outputType === 'Listing');
      break;
    default:
      resultFiles = files;
    }
    // console.log('>>> filtered files:', resultFiles);
    return resultFiles;
  }
  case LOAD_FILES_FILTERED_FAILURE:
    return state;
  default:
    return state;
  }
}

export const isFileLoading = (state = false, action) => {
  const { type } = action;
  switch (type) {
  case LOAD_FILES_IN_PROGRESS:
    return true;
  case LOAD_FILES_SUCCESS:
  case LOAD_FILES_FAILURE:
    return false;
  default:
    return state;
  }
}

export const pageParam = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
  case SET_PAGE_PARAM:
    const { param } = payload;
    return Object.assign({}, state, param );
  case GET_PAGE_PARAM_VALUE:
    const { field } = payload;
    return state[field];
  default:
    return state;
  }
}

export const userInfo = (state = { reviewStatus:[] }, action) => {
  const { type, payload } = action;
  switch (type) {
  case SET_USER_INFO:
    return Object.assign({}, state, payload);
  case GET_USER_INFO:
    return state;
  default:
    return state;
  }
}

export const reviewInfo = (state = {
    showFileDownloadDialog:false,
    milestones:[],
    milestoneId:'',
    downloadType: 'all',
    downloadFormat: 'pdf'
  }, action) => {
  const { type, payload } = action;
  let newState = null;
  switch (type) {
  case SET_REVIEW_INFO:
    return Object.assign({}, state, payload);
  case GET_REVIEW_INFO:
    return state;
  case SET_MILESTONES:
    return Object.assign({}, state, { milestones:payload });
  case SET_MILESTONE_ID:
    let milestone = _.find(payload, { milestone:state.milestone });
    return Object.assign({}, state, { milestoneId:milestone && milestone.milestoneId });
  case GET_SUMMARY_OVERALL_SUCCESS:
    newState = Object.assign({}, state, { summary:payload });
    return newState;
  case GET_DOC_SUMMARY_OVERALL_SUCCESS:
    newState = Object.assign({}, state, { summary:payload });
    return newState;
  case SEND_EMAIL_SUCCESS:
    newState = Object.assign({}, state, { message:payload.message });
    return newState;
  case CLEAR_MESSAGE_DISPLAY:
    newState = Object.assign({}, state, { message:'' });
    return newState;
  case UPDATE_REVIEW_INFO_SUCCESS:
    newState = Object.assign({}, state, payload);
    return newState
  default:
    return state;
  }
}

export const groupInfo = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
  case GET_OUTPUT_REVIEW_STATUS_GROUP_SUCCESS:
    return Object.assign({}, state, payload);
  case GET_DOC_REVIEW_STATUS_GROUP_SUCCESS:
    return Object.assign({}, state, payload);
  case UPDATE_OUTPUT_GROUP_DUE_DATE_SUCCESS:
  case UPDATE_DOC_GROUP_DUE_DATE_SUCCESS:
    // console.log('>>> due date update:', payload);
    return _.transform(state, (result, value, key) => {
      if (key === 'dueDate') {
        result['dueDate'] = payload['dueDate'];
      } else {
        result[key] = value;
      }
    }, {});
  default:
    return state;
  }
}

export const reviewAssignInfo = (state = { reviewers:[] }, action) => {
  let reviewers = null;
  const { type, payload } = action;
  switch (type) {
  case SET_REVIEW_ASSIGN_INFO:
    return Object.assign({}, state, payload);
  case GET_REVIEW_ASSIGN_INFO:
    return state;
  case REMOVE_REVIEW_ASSIGN:
    reviewers = state.reviewers || [];
    // console.log('--> REMOVE_REVIEW_ASSIGN payload:', payload, ' reviewers:', JSON.stringify(reviewers));
    if (_.find(reviewers, { userId:payload})) {
      reviewers = _.filter(reviewers, function(reviewer) {
        return reviewer.userId !== payload;
      });
    }
    // console.log('--> REMOVE_REVIEW_ASSIGN payload 2:', payload, ' reviewers:', JSON.stringify(reviewers));
    return Object.assign({}, state, { reviewers });
  case ADD_REVIEW_ASSIGN:
    reviewers = state.reviewers || [];
    if (!_.find(reviewers, { userId:payload})) {
      reviewers.push({ userId:payload, selected:true });
    }
    // console.log('--> ADD_REVIEW_ASSIGN payload:', payload, ' reviewers:', reviewers);
    return Object.assign({}, state, { reviewers });
  case UPDATE_REVIEW_ASSIGN_SELECT:
    // console.log('>>> UPDATE_REVIEW_ASSIGN_SELECT payload:', payload);
    // payload: {userId: 'jcao', selected: true}
    reviewers = state.reviewers || [];
    reviewers = _.map(reviewers, (reviewer) => {
      if (reviewer.userId === payload.userId) {
        reviewer.selected = payload.selected;
      }
      return reviewer;
    });
    // console.log('--> UPDATE_REVIEW_ASSIGN_SELECT reviewers:', reviewers);
    return { reviewers, show:state.show};
  case UPDATE_REVIEW_ASSIGN_ALLOW_DOWNLOAD:
    // console.log('>>> UPDATE_REVIEW_ASSIGN_ALLOW_DOWNLOAD payload:', payload);
    // payload: {userId: 'jcao', allowDownload: true}
    reviewers = state.reviewers || [];
    reviewers = _.map(reviewers, (reviewer) => {
      if (reviewer.userId === payload.userId) {
        reviewer.allowDownload = payload.allowDownload;
      }
      return reviewer;
    });
    console.log('--> UPDATE_REVIEW_ASSIGN_ALLOW_DOWNLOAD reviewers:', reviewers);
    return { reviewers, show:state.show};
  default:
    return state;
  }
}

export const users = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
  case SET_USERS:
    // console.log('>>> users reducer result:', payload);
    return payload || [];
  case GET_USERS:
    return state;
  default:
    return state;
  }
}

export const loginInfo = (state = {
    smsChecked:false, emailChecked:false, infoSendStatus:'', loginStatus:''
  }, action) => {
  const { type, payload } = action;
  switch (type) {
  case SET_LOGIN_INFO:
    return Object.assign({}, state, payload);
  case SET_USER_INFO:
    let result = { smsChecked:false, emailChecked:false };
    if (payload.mobilePhone) {
      result.smsChecked = true;
    } else if (payload.emailAddress) {
      result.emailChecked = true;
    }
    return result;
  case SEND_INFO_SUCCESS:
    return Object.assign({}, state, payload); // { infoSendStatus:'Information is sent successfully' });
  case SEND_INFO_FAILURE:
    return Object.assign({}, state, payload); // { infoSendStatus:'failed to send information' });
  case USER_LOGIN_SUCCESS:
    return Object.assign({}, state, payload); // { loginStatus:'User login is successfully' });
  case USER_LOGIN_FAILURE:
    return Object.assign({}, state, payload); // { loginStatus:'User login failed' });
  default:
    return state;
  }
}

export const adhocInfo = (state = {
    showCreateDialog: false,
    searchParameter: {
      program: '',
      study: '',
      milestone: '',
    },
    records: [],
    currentRecord: {},
    editRecord: {},
    AdhocRequestStatus: [],
    requesters: [],
    mode: 'create'
  }, action) => {
  const { type, payload } = action;
  let editRecord = null;
  let fileMeta = null;
  let file = null;
  switch (type) {
  case UPDATE_ADHOC_INFO_SUCCESS:
    return Object.assign({}, state, payload);
  case GET_ADHOC_CONTROL_VALUE_SUCCESS:
    return Object.assign({}, state, payload);
  case SEARCH_ADHOC_SUCCESS:
    return Object.assign({}, state, payload);
  case GET_ADHOC_REQUEST_SUCCESS:
    // console.log('>>> GET_ADHOC_REQUEST_SUCCESS payload:', payload);
    return Object.assign({}, state, { editRecord:payload.record });
  case GET_ADHOC_REQUESTERS_SUCCESS:
    // console.log('>>> GET_ADHOC_REQUESTERS_SUCCESS payload:', payload);
    return Object.assign({}, state, { requesters:payload.records });
  case UPDATE_ADHOC_ATTACHMENTS_SUCCESS:
    // console.log('>>> UPDATE_ADHOC_ATTACHMENTS_SUCCESS payload:', payload);
    editRecord = Object.assign({}, state.editRecord);
    // console.log('>>> editRecord:', editRecord);
    switch(payload.action) {
      case 'add':
        // console.log('>>> UPDATE_ADHOC_ATTACHMENTS_SUCCESS add', payload.file);
        fileMeta = payload.file.meta;
        file = { file_id:'', key:fileMeta.key, file_name:fileMeta.name };
        // console.log('>>> file:', file);
        // console.log('>>> editRecord 2:', editRecord);
        editRecord.attachments = editRecord.attachments || [];
        editRecord.attachments.push(file);
        // console.log('>>> editRecord 3:', editRecord);
        // console.log('>>> editRecord.attachments:', editRecord.attachments);
      break;
    }
    // console.log('>>> return:', Object.assign({}, state, { editRecord:editRecord }));
    return Object.assign({}, state, { editRecord:editRecord });
  case REMOVE_ADHOC_ATTACHMENT_SUCCESS:
    // remove attachement (pass in as payload)
    editRecord = Object.assign({}, state.editRecord);
    console.log('>>> remove adhoc attachment:', payload);
    // >>> remove adhoc attachment: {file_id: 8, file_name: "Articles with full text.docx", document_location: "C:\BPSApp\bps\Workspace\uploads\adhocrequest\6df898a6-b068-4e86-8ff1-dbcf11552c68.docx"}
    // >>> remove adhoc attachment: {file_id: "", key: "c16fd976-556a-49f2-9e27-ab614bafb048", file_name: "Screen Shot 2021-03-01 at 7.44.42 PM.png"}
    // payload.file_id - existing attachment
    // payload.key - new attachment
    if (payload.key) {
      // attachment to be removed is newly uploaded in UI, its file_id is blank
      editRecord.attachments = _.filter(editRecord.attachments,
        (attachment) => attachment.key !== payload.key);
    } else {
      // attachment to be removed is saved and needs to be marked for removal in backend
      // set attachment.to_remove to true
      editRecord.attachments = _.map(editRecord.attachments,
        (attachment) => {
          if (attachment.file_id === payload.file_id) {
            attachment.to_remove = true;
          }
          return attachment;
        }
      )
    }
    return Object.assign({}, state, { editRecord:editRecord });
  case UPDATE_ADHOC_IMAGE_SUCCESS:
    editRecord = Object.assign({}, state.editRecord);
    fileMeta = payload.file.meta;
    console.log('>>> UPDATE_ADHOC_IMAGE_SUCCESS payload:', payload);
    file = { file_id:'', key:fileMeta.key, file_name:fileMeta.name };
    editRecord.image = file;
    return Object.assign({}, state, { editRecord:editRecord });
  case REMOVE_ADHOC_IMAGE_SUCCESS:
    console.log('>>> REMOVE_ADHOC_IMAGE_SUCCESS payload:', payload);
    editRecord = Object.assign({}, state.editRecord);
    if (payload.key) {
      // image to be removed is newly uploaded in UI, its file_id is blank
      editRecord.image = null;
    } else {
      // image to be removed is saved and needs to be marked for removal in backend
      // set image.to_remove to true
      editRecord.image.to_remove = true;
    }
    return Object.assign({}, state, { editRecord:editRecord });
  default:
    return state;
  }
}

export const searchInfo = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
  case SET_SEARCH_INFO:
    console.log('>>> searchInfo SET_SEARCH_INFO:', payload);
    return Object.assign({}, state, payload);
  default:
    return state;
  }
}
